import React, { useContext , useState , useEffect  } from 'react';
import {  doc , db   , setDoc ,query , where , deleteDoc , collection , getDocs } from '../firebase';




const PackageComponent = ( {  id , service_name , service_desc , service_provider  , item_price , rating , image } ) => {

  const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

  const [userAddedPackage , setUserAddedPackage] = useState(true);

  const [foundedCartPackage , setFoundedCartPackage] = useState('');


    const makeid = (length) =>  {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

  useEffect(() => {

    const checkIfPackagedAdded = async () => {
      const q = query(collection(db, `cart ${user.id}`), where("id", "==", id )  );
       
      const querySnapshot = await getDocs(q);
    
      const packagesDataArray = querySnapshot.docs ? querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) : '';
  
   setFoundedCartPackage(packagesDataArray);
     
      if (packagesDataArray.length === 0 ) {
        setUserAddedPackage(false);
      }
    }

    checkIfPackagedAdded();


} , [userAddedPackage]);

  
  const addCartToDb = async () => {

    setUserAddedPackage(!userAddedPackage);

    const cart = await setDoc(doc(db, `cart ${user.id}`, makeid(20)), {
      name : service_name,
      image: image,
      price: item_price,
      service_provider: service_provider ,
      description : service_desc,
      status: 'wait-payment',
      id: id
    
      
     
      });

  }

  const removeCartFromDb = async () => { 
    setUserAddedPackage(!userAddedPackage);
    await deleteDoc(doc(db, `cart ${user.id}`, foundedCartPackage[0].id ));

  }


  return (
    <div className='single_package_item' >
    <img src={image} alt="" className="package_image" />
    <div className="mt-1-small"></div>
    <div className="body_package_card">

  <h1 className="location_slidetwo_headline"> {service_name} </h1>
  <div className="mt-1-small"></div>
<p className="main_para_small">  {service_desc} </p>

<div className="mt-1-small"></div>
<div className="d-flex-c  stars_location mt-1">
 
<img src="/images/icons/star.png" alt="" className="star_icon_small" />
<img src="/images/icons/star.png" alt="" className="star_icon_small" />
<img src="/images/icons/star.png" alt="" className="star_icon_small" />
<img src="/images/icons/star.png" alt="" className="star_icon_small" />
<img src="/images/icons/star.png" alt="" className="star_icon_small" />
      
      
  </div>

<div className="mt-1-small"></div>
<h1 className="location_slidetwo_headline_sm">  مقدم الخدمة : {service_provider}   </h1>


    {userAddedPackage ? (
      <div className='' >
      <button  className="mt-1 btn_pricing mx-2 bg_red w-30" onClick={() => removeCartFromDb() }  > ❌ الغاء   </button> 
     
      <button  className="mt-1 btn_pricing w-30"  > ✅ تم الحجز  </button> 
    
      </div>
    
    ) : (
      <div onClick={() => addCartToDb() } >
      <button  className="mt-1 btn_pricing p-3"  >احجز الان : <span className="span_bold"> {item_price} </span> ريال</button> 
      </div>
     
    )}


    </div>

  </div>
  )
}

export default PackageComponent